// import React, { useState, useEffect } from "react";
// import {
//   Menu,
//   X,
//   Sparkles,
//   Brain,
//   ScanSearch,
//   LayoutDashboard,
//   History,
//   FileText,
//   LogOut,
//   Settings
// } from "lucide-react";
// import { cn } from "../../lib/utils";

// const menuItems = [
//   {
//     icon: <LayoutDashboard className="h-5 w-5" />,
//     title: "Dashboard ",
//     path: "dashboard",
//   },
//   {
//     icon: <History className="h-5 w-5" />,
//     title: "Defect Library",
//     path: "historie",
//   },
//   {
//     icon: <ScanSearch className="h-5 w-5" />,
//     title: "Defect Explorer",
//     path: "DefectViewer",
//   },
//   {
//     icon: <FileText className="h-5 w-5" />,
//     title: "Reports",
//     path: "reports",
//   },
//   {
//     icon: <Brain className="w-5 h-5" />,
//     title: "Ask Shaheen AI",
//     path: "Chatbot",
//   },
// ];

// const Layout = ({ children, activePage, onPageChange, onLogout, user }) => {
//   const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

//   useEffect(() => {
//     return () => {
//       setIsMobileSidebarOpen(false);
//     };
//   }, []);

//   const handleMenuClick = (path) => {
//     onPageChange(path);
//     setIsMobileSidebarOpen(false);
//   };

//   const handleLogoutClick = () => {
//     if (onLogout) {
//       onLogout();
//       setIsMobileSidebarOpen(false);
//     }
//   };

//   const SidebarContent = () => (
//     <div className="flex flex-col h-full">
//       <nav className="flex-1 px-3 py-4">
//         {menuItems.map((item) => (
//           <button
//             key={item.path}
//             onClick={() => handleMenuClick(item.path)}
//             className={cn(
//               "w-full flex items-center px-3 py-2 rounded-lg mb-1 text-sm",
//               "transition-colors duration-200 group",
//               activePage === item.path
//                 ? "bg-gradient-to-r from-blue-500/10 to-cyan-500/10 text-cyan-300 "
//                 : "text-gray-400 hover:bg-gray-800 hover:text-white",
//               item.title === "Ask Brain AI" && "bg-gradient-to-r from-blue-600 to-cyan-600 text-white hover:text-sky-200"
//             )}
//           >
//             <span className="flex items-center gap-3">
//               {item.icon}
//               {item.title}
//             </span>
//           </button>
//         ))}
//       </nav>

//       <div className="px-3 py-4 border-t border-gray-800">
//         <button
//           onClick={() => handleMenuClick("settings")}
//           className={cn(
//             "w-full flex items-center px-3 py-2 rounded-lg mb-4 text-sm",
//             "transition-colors duration-200",
//             activePage === "settings"
//               ? "bg-gradient-to-r from-blue-500/10 to-cyan-500/10 text-cyan-300"
//               : "text-gray-400 hover:bg-gray-800 hover:text-white"
//           )}
//         >
//           <span className="flex items-center gap-3">
//             <Settings className="h-5 w-5" />
//             Settings
//           </span>
//         </button>

//         <div className="text-center mb-4">
//           <p className="text-xs text-gray-500">Licence ID: {user.username}</p>
//         </div>

//         <button
//           onClick={handleLogoutClick}
//           className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200"
//         >
//           <LogOut className="h-4 w-4" />
//           <span>Sign out</span>
//         </button>
//       </div>
//     </div>
//   );

//   return (
//     <div className="h-screen flex flex-col md:flex-row bg-[#0F1216] overflow-hidden">
//       <div className="hidden md:flex flex-col w-64 bg-[#171B21] border-r border-gray-800">
//         <div className="h-16 flex items-center px-4 border-b border-gray-800">
//           <div className="flex items-center space-x-3 h-16">
//             <img
//               src="/logo.png"
//               alt="Nommas AI"
//               className="h-12 w-auto"
//               style={{ objectFit: "contain", maxWidth: "200px" }}
//             />
//           </div>
//         </div>
//         <SidebarContent />
//       </div>

//       <div
//         className={cn(
//           "fixed inset-y-0 left-0 w-64 bg-[#171B21] transition-all duration-300 ease-in-out z-50 md:hidden",
//           isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
//         )}
//       >
//         <button
//           onClick={() => setIsMobileSidebarOpen(false)}
//           className="absolute right-4 top-5 text-gray-400 hover:text-white"
//         >
//           <X className="h-6 w-6" />
//         </button>
//         <div className="h-16 flex items-center px-4 border-b border-gray-800">
//           <div className="flex items-center space-x-3">
//             <img
//               src="/logo.png"
//               alt="Nommas AI"
//               className="h-12 w-auto"
//               style={{ objectFit: "contain", maxWidth: "200px" }}
//             />
//           </div>
//         </div>
//         <SidebarContent />
//       </div>

//       <div className="flex-1 flex flex-col min-h-screen md:min-h-0">
//         <div className="h-16 flex-none bg-[#171B21] border-b border-gray-800 flex items-center px-4">
//           <div className="flex items-center justify-between w-full">
//             <div className="flex items-center gap-4">
//               <button
//                 onClick={() => setIsMobileSidebarOpen(true)}
//                 className="text-gray-400 hover:text-white p-1.5 md:hidden"
//               >
//                 <Menu className="h-5 w-5" />
//               </button>
//               <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent text-lg font-medium">
//                 {menuItems.find((item) => item.path === activePage)?.title || (activePage === "settings" ? "Settings" : "")}
//               </span>
//             </div>
//             <button
//               onClick={handleLogoutClick}
//               className="md:hidden flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200"
//             >
//               <LogOut className="h-4 w-4" />
//               <span>Sign out</span>
//             </button>
//           </div>
//         </div>

//         <div
//           className="flex-1 overflow-y-auto scroll-smooth -mr-2 space-y-4"
//           style={{
//             scrollbarWidth: "thin",
//             scrollbarColor: "#1f2937 transparent",
//           }}
//         >
//           <div className="h-full">{children}</div>
//         </div>
//       </div>

//       {isMobileSidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black/50 z-40 md:hidden"
//           onClick={() => setIsMobileSidebarOpen(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default Layout;


import React, { useState, useEffect } from "react";
import {
  Menu,
  X,
  Sparkles,
  Brain,
  ScanSearch,
  LayoutDashboard,
  History,
  FileText,
  LogOut,
  Settings,
  ChevronLeft,
  ChevronRight
} from "lucide-react";
import { cn } from "../../lib/utils";

const menuItems = [
  {
    icon: <LayoutDashboard className="h-5 w-5" />,
    title: "Dashboard",
    path: "dashboard",
  },
  {
    icon: <History className="h-5 w-5" />,
    title: "Defect Library",
    path: "historie",
  },
  {
    icon: <ScanSearch className="h-5 w-5" />,
    title: "Defect Analytics",
    path: "DefectViewer",
  },
  {
    icon: <FileText className="h-5 w-5" />,
    title: "Reports",
    path: "reports",
  },
  {
    icon: <Brain className="w-5 h-5" />,
    title: "Ask Shaheen AI",
    path: "Chatbot",
  },
];

const Layout = ({ children, activePage, onPageChange, onLogout, user }) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    return () => {
      setIsMobileSidebarOpen(false);
    };
  }, []);

  const handleMenuClick = (path) => {
    onPageChange(path);
    setIsMobileSidebarOpen(false);
  };

  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
      setIsMobileSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const SidebarContent = () => (
    <div className="flex flex-col h-full relative">
      <button
        onClick={toggleSidebar}
        className="absolute -right-3 -top-3 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 hover:from-blue-500/20 hover:to-cyan-500/20 text-cyan-300 rounded-full p-1 shadow-lg transform transition-all duration-200 hover:scale-110 z-50 border border-gray-700"
      >
        {isCollapsed ? (
          <ChevronRight className="h-4 w-4" />
        ) : (
          <ChevronLeft className="h-4 w-4" />
        )}
      </button>

      <nav className="flex-1 px-3 py-4">
        {menuItems.map((item) => (
          <button
            key={item.path}
            onClick={() => handleMenuClick(item.path)}
            className={cn(
              "w-full flex items-center px-3 py-2 rounded-lg mb-1",
              "transition-all duration-200 group relative",
              activePage === item.path
                ? "bg-gradient-to-r from-blue-500/10 to-cyan-500/10 text-cyan-300"
                : "text-gray-400 hover:bg-gray-800 hover:text-white",
              item.title === "Ask Shaheen AI" && "bg-gradient-to-r from-blue-600 to-cyan-600 text-white hover:text-sky-200"
            )}
          >
            <span className="flex items-center gap-3">
              {item.icon}
              <span className={cn(
                "text-sm transition-all duration-200",
                isCollapsed ? "opacity-0 w-0" : "opacity-100 w-auto"
              )}>
                {item.title}
              </span>
            </span>
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">
                {item.title}
              </div>
            )}
          </button>
        ))}
      </nav>

      <div className={cn(
        "px-3 py-4 border-t border-gray-800 transition-all duration-200",
        isCollapsed ? "text-center" : ""
      )}>
        <button
          onClick={() => handleMenuClick("settings")}
          className={cn(
            "w-full flex items-center px-3 py-2 rounded-lg mb-4 relative group",
            "transition-colors duration-200",
            activePage === "settings"
              ? "bg-gradient-to-r from-blue-500/10 to-cyan-500/10 text-cyan-300"
              : "text-gray-400 hover:bg-gray-800 hover:text-white"
          )}
        >
          <span className="flex items-center gap-3">
            <Settings className="h-5 w-5" />
            <span className={cn(
              "text-sm transition-all duration-200",
              isCollapsed ? "opacity-0 w-0" : "opacity-100 w-auto"
            )}>
              Settings
            </span>
          </span>
          {isCollapsed && (
            <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
              Settings
            </div>
          )}
        </button>

        <div className={cn(
          "text-center mb-4 transition-all duration-200",
          isCollapsed ? "opacity-0" : "opacity-100"
        )}>
          <p className="text-xs text-gray-500">Licence ID: {user.username}</p>
        </div>

        <button
          onClick={handleLogoutClick}
          className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200 relative group"
        >
          <LogOut className="h-4 w-4" />
          <span className={cn(
            "transition-all duration-200",
            isCollapsed ? "opacity-0 w-0" : "opacity-100 w-auto"
          )}>
            Sign out
          </span>
          {isCollapsed && (
            <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
              Sign out
            </div>
          )}
        </button>
      </div>
    </div>
  );

  return (
    <div className="h-screen flex flex-col md:flex-row bg-[#0F1216] overflow-hidden">
      <div className={cn(
        "hidden md:flex flex-col bg-[#171B21] border-r border-gray-800 transition-all duration-300",
        isCollapsed ? "w-20" : "w-64"
      )}>
        <div className={cn(
          "h-16 flex items-center px-4 border-b border-gray-800 transition-all duration-300",
          isCollapsed ? "justify-center" : ""
        )}>
          <div className={cn(
            "flex items-center justify-center h-16 transition-all duration-300 overflow-hidden",
            isCollapsed ? "w-0 opacity-0" : "w-auto opacity-100"
          )}>
            <img
              src="/logo.png"
              alt="Nommas AI"
              className="h-12 w-auto object-contain max-w-[200px]"
            />
          </div>
        </div>
        <SidebarContent />
      </div>

      {/* Mobile Sidebar */}
      <div
        className={cn(
          "fixed inset-y-0 left-0 w-64 bg-[#171B21] transition-all duration-300 ease-in-out z-50 md:hidden",
          isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
        )}
      >
        <div className="flex flex-col h-full">
          <div className="h-16 flex items-center justify-between px-4 border-b border-gray-800">
            <div className="flex items-center space-x-3">
              <img
                src="/logo.png"
                alt="Nommas AI"
                className="h-12 w-auto"
                style={{ objectFit: "contain", maxWidth: "200px" }}
              />
            </div>
            <button
              onClick={() => setIsMobileSidebarOpen(false)}
              className="text-gray-400 hover:text-white p-1"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto">
            <SidebarContent />
          </div>
        </div>
      </div>

      <div className="flex-1 flex flex-col min-h-screen md:min-h-0">
        <div className="h-16 flex-none bg-[#171B21] border-b border-gray-800 flex items-center px-4">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsMobileSidebarOpen(true)}
                className="text-gray-400 hover:text-white p-1.5 md:hidden"
              >
                <Menu className="h-5 w-5" />
              </button>
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent text-lg font-medium">
                {menuItems.find((item) => item.path === activePage)?.title || (activePage === "settings" ? "Settings" : "")}
              </span>
            </div>
            <button
              onClick={handleLogoutClick}
              className="md:hidden flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200"
            >
              <LogOut className="h-4 w-4" />
              <span>Sign out</span>
            </button>
          </div>
        </div>

        <div
          className="flex-1 overflow-y-auto scroll-smooth -mr-2 space-y-4"
          style={{
            scrollbarWidth: "thin",
            scrollbarColor: "#1f2937 transparent",
          }}
        >
          <div className="h-full">{children}</div>
        </div>
      </div>

      {isMobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setIsMobileSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default Layout;